var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoldStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0095 0.389787L9.59766 2.48993H13.0566V8.32877e-06C12.6833 -0.00119842 12.3096 0.128728 12.0095 0.389787Z",
    fill: "#FDF0BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.092 0.387366C13.7951 0.130329 13.4271 0.00120675 13.0586 0V2.48992H16.5175L14.092 0.387366Z",
    fill: "url(#paint0_linear_2748_272879)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64602 3.83276L4.14844 6.99202L6.79805 4.76879L5.1975 2.86133C4.9107 3.10026 4.70797 3.44016 4.64602 3.83276Z",
    fill: "#FDF0BC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23593 2.49484C5.84334 2.48841 5.47809 2.62638 5.19531 2.8625L6.79586 4.76996L9.44547 2.54673L6.23593 2.49484Z",
    fill: "url(#paint1_linear_2748_272879)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.21551 11.2051L2.86473 13.9453L3.46529 10.539L1.01358 10.1062C0.947212 10.4739 1.01036 10.8644 1.21551 11.2051Z",
    fill: "#FDF0BC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.57636 9.15734C1.27186 9.40513 1.08079 9.74543 1.01562 10.1079L3.46773 10.5403L4.06829 7.13403L1.57636 9.15734Z",
    fill: "url(#paint2_linear_2748_272879)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.32956 19.0587L6.35447 20.0974L4.62521 17.1018L2.46875 18.3468C2.65419 18.671 2.95346 18.9296 3.32956 19.0587Z",
    fill: "url(#paint3_linear_2748_272879)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.28672 17.2598C2.2123 17.6451 2.28471 18.0289 2.46773 18.3487L4.62419 17.1037L2.89492 14.1082L2.28672 17.2598Z",
    fill: "url(#paint4_linear_2748_272879)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99595 23.7167L12.9806 22.5683L9.73047 21.3853L8.87891 23.7251C9.22926 23.8539 9.62508 23.8595 9.99595 23.7167Z",
    fill: "url(#paint5_linear_2748_272879)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03648 23.0072C8.22715 23.3503 8.52924 23.5977 8.87517 23.7248L9.72673 21.3849L6.47656 20.2019L8.03648 23.0072Z",
    fill: "url(#paint6_linear_2748_272879)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0925 23.0003L19.6408 20.2019L16.3906 21.3849L17.2422 23.7248C17.5929 23.5981 17.8999 23.3483 18.0925 23.0003Z",
    fill: "url(#paint7_linear_2748_272879)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1386 23.7147C16.5054 23.8551 16.8956 23.8502 17.2424 23.7251L16.3908 21.3853L13.1406 22.5683L16.1386 23.7147Z",
    fill: "url(#paint8_linear_2748_272879)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.838 17.2469L23.2254 14.1082L21.4961 17.1037L23.6525 18.3487C23.84 18.0257 23.9144 17.6371 23.838 17.2469Z",
    fill: "url(#paint9_linear_2748_272879)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.799 19.0483C23.1699 18.92 23.4659 18.6653 23.6513 18.3468L21.4949 17.1018L19.7656 20.0974L22.799 19.0483Z",
    fill: "url(#paint10_linear_2748_272879)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5379 9.14447L22.0508 7.13403L22.6513 10.5403L25.1034 10.1079C25.0403 9.7402 24.8472 9.39467 24.5379 9.14447Z",
    fill: "url(#paint11_linear_2748_272879)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9025 11.1915C25.1045 10.8548 25.1676 10.4694 25.1045 10.1062L22.6523 10.5386L23.2529 13.9449L24.9025 11.1915Z",
    fill: "url(#paint12_linear_2748_272879)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8693 2.48635L16.6719 2.54468L19.3215 4.76791L20.922 2.86044C20.6368 2.6199 20.2672 2.47911 19.8693 2.48635Z",
    fill: "url(#paint13_linear_2748_272879)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4635 3.8223C21.4015 3.43453 21.2024 3.09906 20.9209 2.86133L19.3203 4.76879L21.9699 6.99202L21.4635 3.8223Z",
    fill: "url(#paint14_linear_2748_272879)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0527 20.6786C17.718 20.6786 21.4999 16.8967 21.4999 12.2314C21.4999 7.56613 17.718 3.78418 13.0527 3.78418C8.38742 3.78418 4.60547 7.56613 4.60547 12.2314C4.60547 16.8967 8.38742 20.6786 13.0527 20.6786Z",
    fill: "url(#paint15_radial_2748_272879)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0534 3.0293C7.97139 3.0293 3.85156 7.14873 3.85156 12.2307C3.85156 17.3127 7.97139 21.4326 13.0534 21.4326C18.1354 21.4326 22.2552 17.3127 22.2552 12.2307C22.2552 7.14873 18.1354 3.0293 13.0534 3.0293ZM13.0534 20.6772C8.38853 20.6772 4.60699 16.8956 4.60699 12.2307C4.60699 7.56586 8.38853 3.78432 13.0534 3.78432C17.7183 3.78432 21.4998 7.56586 21.4998 12.2307C21.4998 16.8956 17.7183 20.6772 13.0534 20.6772Z",
    fill: "url(#paint16_linear_2748_272879)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0553 1.85449C7.32486 1.85449 2.67969 6.49966 2.67969 12.2301C2.67969 17.9605 7.32486 22.6057 13.0553 22.6057C18.7857 22.6057 23.4309 17.9605 23.4309 12.2301C23.4309 6.49966 18.7857 1.85449 13.0553 1.85449ZM13.0553 21.4275C7.97569 21.4275 3.85787 17.3097 3.85787 12.2301C3.85787 7.1505 7.97569 3.03308 13.0553 3.03308C18.1349 3.03308 22.2527 7.1509 22.2527 12.2305C22.2527 17.3101 18.1349 21.4275 13.0553 21.4275Z",
    fill: "url(#paint17_linear_2748_272879)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7325 16.4656C10.5917 16.4656 10.461 16.4206 10.3455 16.3401C10.3306 16.3301 10.3206 16.32 10.3105 16.31C10.3005 16.3051 10.2952 16.2951 10.2904 16.2899C10.2703 16.2746 10.2602 16.2597 10.2454 16.2448C10.2353 16.2348 10.2301 16.2247 10.2204 16.2146L10.2156 16.2098C10.2055 16.1998 10.2003 16.1897 10.1955 16.1796L10.1854 16.1644C10.1653 16.1342 10.1504 16.104 10.1351 16.0739C10.1303 16.059 10.1251 16.0437 10.1199 16.0288C10.115 16.0135 10.1098 15.9938 10.105 15.9785C10.0998 15.9584 10.0949 15.9335 10.0897 15.9081C10.0897 15.8981 10.0849 15.8832 10.0849 15.8731C10.0849 15.853 10.08 15.8329 10.08 15.8128C10.08 15.7778 10.0849 15.7424 10.0901 15.7022L10.4771 13.4512L8.84393 11.8583C8.81376 11.8281 8.78359 11.7931 8.75865 11.7577C8.72849 11.7127 8.70837 11.6773 8.69349 11.637C8.68866 11.6222 8.67861 11.6021 8.67338 11.5767C8.65809 11.5164 8.64844 11.456 8.64844 11.3909C8.64844 11.3708 8.64844 11.3559 8.64844 11.3358C8.64844 11.3056 8.65326 11.2754 8.66332 11.2453C8.66332 11.2404 8.66815 11.2304 8.66815 11.2251C8.67338 11.2099 8.67338 11.195 8.6782 11.1801C8.6782 11.1753 8.68303 11.1648 8.68826 11.1499C8.69309 11.1346 8.69832 11.1198 8.70837 11.1049C8.72326 11.0747 8.73854 11.0445 8.76348 11.0095C8.77354 10.9894 8.78842 10.9745 8.80371 10.9593C8.80371 10.9593 8.80371 10.9544 8.80853 10.9544L8.88898 10.8237H8.95938C8.96943 10.8185 8.97426 10.8136 8.98432 10.8084C8.99437 10.8036 9.01448 10.7935 9.02937 10.7835C9.04948 10.7734 9.07442 10.7634 9.10459 10.7533C9.11464 10.7485 9.12953 10.7433 9.14481 10.7433C9.16493 10.7384 9.18504 10.7332 9.20998 10.728L11.471 10.4013L12.4658 8.36636C12.5764 8.1403 12.8025 7.99951 13.0535 7.99951C13.2345 7.99951 13.4103 8.07473 13.5358 8.20546C13.5559 8.2304 13.576 8.25052 13.5909 8.27586C13.611 8.30603 13.6311 8.33619 13.646 8.36636L14.656 10.4062L16.9118 10.7328C17.1632 10.7678 17.3692 10.944 17.4444 11.1849C17.4496 11.2002 17.4545 11.2099 17.4545 11.2251C17.4545 11.23 17.4545 11.23 17.4593 11.2352C17.4641 11.2505 17.4694 11.2654 17.4694 11.2855C17.4694 11.2903 17.4694 11.2903 17.4694 11.2955C17.4742 11.3157 17.4742 11.3305 17.4742 11.3506C17.4794 11.446 17.4641 11.5465 17.4239 11.637C17.4086 11.6773 17.3889 11.7123 17.3636 11.7477L17.3583 11.7525C17.3334 11.7875 17.3032 11.8229 17.2731 11.8531L15.6399 13.446L16.0269 15.6917C16.0671 15.9379 15.9718 16.1841 15.7654 16.3349C15.7151 16.3699 15.6548 16.4053 15.5945 16.4254C15.5892 16.4254 15.5844 16.4306 15.5744 16.4306C15.5092 16.4508 15.4436 16.4608 15.3785 16.4608C15.2731 16.4608 15.1673 16.4359 15.0719 16.3856L13.0523 15.3253L11.0326 16.3856C10.9433 16.4407 10.8379 16.4656 10.7325 16.4656Z",
    fill: "#DF771E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0549 8.32153V12.4768L11.668 10.7032L12.7532 8.50777C12.8188 8.3871 12.9395 8.32153 13.0549 8.32153Z",
    fill: "#FFFAF6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1386 11.2908L13.0586 12.4766L14.4451 10.7031L16.8671 11.0547C17.003 11.0796 17.0984 11.175 17.1386 11.2908Z",
    fill: "#FEE0AC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5768 16.0774L13.0547 12.4749L15.2956 13.3341L15.7075 15.7459C15.7373 15.8867 15.6769 16.007 15.5768 16.0774Z",
    fill: "#ECB76B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0498 12.4749V14.962L10.8841 16.1023C10.7586 16.1675 10.6279 16.1474 10.5273 16.0774L13.0498 12.4749Z",
    fill: "#F1A341"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4416 10.7032L13.0547 12.4768V8.32153C13.1452 8.32153 13.2357 8.35653 13.3009 8.42692C13.3109 8.43698 13.321 8.45186 13.331 8.46715C13.3411 8.48243 13.3511 8.49732 13.356 8.5122L14.4416 10.7032Z",
    fill: "#FFE9BA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1281 11.5169C17.1181 11.537 17.108 11.5571 17.098 11.5772C17.0827 11.5973 17.0678 11.6122 17.0529 11.6323L15.2995 13.3407L13.0586 12.4815L17.1386 11.2957C17.1386 11.3005 17.1434 11.3057 17.1434 11.3109C17.1434 11.3162 17.1487 11.321 17.1487 11.3311C17.1487 11.3363 17.1487 11.3363 17.1487 11.3363C17.1487 11.3411 17.1487 11.3463 17.1487 11.3512C17.1487 11.3612 17.1487 11.3665 17.1487 11.3761C17.1535 11.4212 17.1483 11.4714 17.1281 11.5169Z",
    fill: "#E49632"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5772 16.0774C15.5522 16.0975 15.5221 16.1124 15.4867 16.1224C15.4819 16.1224 15.4819 16.1224 15.4766 16.1273C15.3962 16.1522 15.3057 16.1474 15.2204 16.1023L13.0547 14.962V12.4749L15.5772 16.0774Z",
    fill: "#E29136"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0548 12.4749L10.5327 16.0774C10.5278 16.0722 10.5226 16.0673 10.5178 16.0621C10.513 16.0573 10.5077 16.0521 10.5025 16.0468C10.4977 16.042 10.4924 16.0368 10.4824 16.0267C10.4772 16.0219 10.4723 16.0167 10.4671 16.0114C10.4619 16.0062 10.4623 16.0066 10.4623 16.0014C10.4575 15.9965 10.4522 15.9913 10.4522 15.9861C10.4422 15.9712 10.4321 15.9559 10.4273 15.941C10.4225 15.9362 10.4225 15.9257 10.4172 15.9161C10.4124 15.906 10.4124 15.9008 10.4072 15.8912C10.4023 15.8811 10.4023 15.8662 10.4023 15.8562C10.4023 15.8513 10.4023 15.8409 10.4023 15.836C10.4023 15.826 10.4023 15.8159 10.4023 15.8059C10.4023 15.7858 10.4023 15.7657 10.4072 15.7455L10.8191 13.3337L13.0548 12.4749Z",
    fill: "#FED891"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0527 12.476L8.97266 11.2901C8.97266 11.2853 8.97748 11.2801 8.97748 11.2748C8.98231 11.2648 8.98231 11.2547 8.98754 11.2499C8.9976 11.2298 9.00765 11.2149 9.01771 11.1996C9.02254 11.1896 9.02776 11.1843 9.03782 11.1747C9.04305 11.1699 9.04788 11.1594 9.05793 11.1546C9.06276 11.1497 9.07322 11.1397 9.07805 11.1345C9.08287 11.1292 9.09293 11.1244 9.09816 11.1192C9.10821 11.1144 9.11827 11.1039 9.12833 11.0991C9.13315 11.0942 9.14321 11.089 9.15327 11.089C9.16855 11.0842 9.17821 11.079 9.19349 11.0737C9.19832 11.0737 9.20355 11.0689 9.2136 11.0689C9.22366 11.0641 9.23854 11.0641 9.25383 11.0588L11.6758 10.7073L13.0527 12.476Z",
    fill: "#FFF3D9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0545 12.4758L10.8188 13.3398L9.06541 11.6315C9.04529 11.6162 9.03524 11.5965 9.02035 11.5764C9.0103 11.5563 8.99541 11.5362 8.99019 11.516C8.98536 11.506 8.98013 11.4959 8.98013 11.4859C8.97007 11.4557 8.96484 11.4207 8.96484 11.3905C8.96484 11.3805 8.96484 11.3704 8.96484 11.3604C8.96484 11.3455 8.96484 11.3354 8.97007 11.3202C8.97007 11.3153 8.9749 11.3101 8.9749 11.3C8.9749 11.2952 8.97973 11.29 8.97973 11.2852L13.0545 12.4758Z",
    fill: "#ECB76B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2748_272879",
    x1: 13.2277,
    y1: 1.24496,
    x2: 16.404,
    y2: 1.24496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE998"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC15B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2748_272879",
    x1: 6.16246,
    y1: 3.67535,
    x2: 9.33244,
    y2: 1.01521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE998"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC15B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2748_272879",
    x1: 4.12502,
    y1: 7.12691,
    x2: 2.3362,
    y2: 10.0657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2748_272879",
    x1: 3.2843,
    y1: 17.6546,
    x2: 6.39345,
    y2: 19.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED892B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2748_272879",
    x1: 2.93038,
    y1: 14.1734,
    x2: 3.48406,
    y2: 17.6658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2748_272879",
    x1: 9.46035,
    y1: 22.5969,
    x2: 12.5269,
    y2: 23.2783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEAC3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F08223"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2748_272879",
    x1: 6.32319,
    y1: 20.1752,
    x2: 9.1342,
    y2: 22.4751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB431"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2748_272879",
    x1: 19.653,
    y1: 20.1819,
    x2: 16.8491,
    y2: 22.5954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAA3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8B1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2748_272879",
    x1: 13.1529,
    y1: 22.7923,
    x2: 16.7306,
    y2: 22.5935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF962D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E56005"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2748_272879",
    x1: 23.3568,
    y1: 14.1207,
    x2: 22.6375,
    y2: 17.6227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBD41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2748_272879",
    x1: 24.2986,
    y1: 14.7358,
    x2: 20.8396,
    y2: 20.7266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6942F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA6F11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2748_272879",
    x1: 21.8772,
    y1: 7.23476,
    x2: 23.9594,
    y2: 10.3202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBD41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2748_272879",
    x1: 23.1233,
    y1: 13.9361,
    x2: 23.9372,
    y2: 10.3396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD9D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2748_272879",
    x1: 20.0816,
    y1: 3.76728,
    x2: 16.8636,
    y2: 2.21507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2748_272879",
    x1: 20.096,
    y1: 3.57026,
    x2: 21.6292,
    y2: 6.97754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_2748_272879",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.0528 12.2312) scale(8.44722)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8428,
    stopColor: "#FAAA31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F57E16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2748_272879",
    x1: 13.0535,
    y1: 3.02914,
    x2: 13.0535,
    y2: 21.4328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0226,
    stopColor: "#FD9A18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3764,
    stopColor: "#FEC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA422"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2748_272879",
    x1: 13.0554,
    y1: 1.82408,
    x2: 13.0554,
    y2: 22.5754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1799,
    stopColor: "#FEE7B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FEE9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2592,
    stopColor: "#FDECD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2953,
    stopColor: "#FEDA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3254,
    stopColor: "#FFCD64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3405,
    stopColor: "#FFC853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7613,
    stopColor: "#FF9114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F57E16"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldStar);
export default __webpack_public_path__ + "static/media/gold-star.43da8797403ebe53c0fac99b25956ddc.svg";
export { ForwardRef as ReactComponent };